export default "__VITE_ASSET__e0b1ce23__"